import Route from '@core/components/Route';
import { RoutePath } from '@core/types/route';
import { ReactNode } from 'react';

export const FALKO_ZANDER_MILESTONES: (ReactNode | string)[] = [
  'geboren 1978 in Berlin',
  'Leiter und Gründer der Systema Akademie Berlin',
  'Leiter und Gründer von Systema "Solovev Defense"',
  'einziger Meister der russischen Kampfkunst "Solovev Style" außerhalb Russlands',
  'Gründer, Vorstand und Abteilungsleiter mehrerer Kampfsport-Vereine, -Abteilungen und -Schulen',
  'seit 1993 Kampfsportler',
  'seit 1996 Kampfsport-Lehrer',
  '1993 - 2006, Ju-Jutsu, 3. Dan DJJV',
  '1998 - 2004, Escrima und WingTsun',
  '1998 - 2006, lizenzierter Prüfer, Kampfrichter, Kursleiter für Frauen-Selbstverteidigung und Fachübungsleiter C im Ju-Jutsu',
  '2000 - 2003, Mitglied der Technischen Kommission im Deutschen Ju-Jutsu Verband e.V.',
  '2000 - 2003, Landeslehrreferent und Vorstand im Brandenburgischen Ju-Jutsu Verband e.V.',
  '2001 - 2008, Referent für "Gewaltprävention, Selbstverteidigung, Selbstbehauptung, Gefahrenanalyse, Deeskalation, Anti-Gewalt und Anti-Aggression" unter anderem bei der AOK Land Brandenburg, AGUS|GADAT BildungsGruppe, Europäische Sportakademie Land Brandenburg, Evangelischer Kirchenkreis Mittelmark-Brandenburg',
  '2001 - 2015, Systema Ryabko',
  '2003 - 2004, Boxen und Taekwondo',
  '2003 - 2004, Referent bei der JVA Brandenburg im Auftrag des HUMANITAS Gefangenenhilfe e.V.; Gesundheitstraining, Integration und Kommunikation mit Gefangenen der Anstalt',
  '2003 - 2007, Leiter und Mitarbeiter im Security-Bereich',
  '2003 - 2009, Dozent für "Deeskalations- sowie Einsatz- und Sicherungstechniken" bei der Justiz des Landes Brandenburg',
  '2004 - 2008, Gründer und Vorstandsvorsitzender des Systema Ost e.V.',
  '2004 - 2015, lizenzierter internationaler Ausbilder für Systema Ryabko',
  '2005 - 2007, Koordinator für Berlin-Brandenburg der European Systema Association e.V.',
  '2006 - 2007, Bundesreferent für Verbandsentwicklung der European Systema Association e.V.',
  '2014 - 2015, Repräsentant für Systema Ryabko in Deutschland',
  <>
    seit 2014, Solovev Style und Solovev Defense,{' '}
    <Route href={RoutePath.KampfkunstRanking}>5. Meistergrad</Route>
  </>,
  '2016 - 2019, Direktor für Solovev Style in Europa',
];
